import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";

Vue.config.productionTip = false;
import DoKoAvatar from "./components/widgets/DoKoAvatar.vue";
import DoKoSymbol from "./components/widgets/DoKoSymbol.vue";
import DoKoCard from "./components/widgets/DoKoCard.vue";
import DokoLoginLogo from "./components/widgets/DokoLoginLogo.vue";

Vue.component("DoKoAvatar", DoKoAvatar);
Vue.component("DoKoSymbol", DoKoSymbol);
Vue.component("DoKoCard", DoKoCard);
Vue.component("DokoLoginLogo", DokoLoginLogo);

declare global {
  interface Window {
    TheFirebase?: firebase.app.App;
    TheApp?: Vue;
    vuexStore?: unknown;
  }
}

window.vuexStore = store;

window.TheApp = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#doko-goes-digital");
